<h1
  class="bg-base-primary font-extrabold location__title pl-16 py-10 text-7xl 2lg:text-9xl text-white bg-cover bg-no-repeat bg-center"
  style="background-image: url('assets/images/textura-ea.jpg')"
>
  {{ 'global.location' | translate }}
</h1>
<div class="location__container" *ngIf="school$ | async as school">
  <iframe
    class="location__map"
    loading="lazy"
    [src]="this.locationMap(school) | safe: 'resourceUrl'"
    allowfullscreen=""
    loading="lazy"
    title="Localização"
  ></iframe>
</div>
